import { CoachPanel } from '../components/CoachPanel';

export function CoachPage() {
  return <CoachPanel className="coach-page" />;
}
